import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://ecf2611026fd422af7aece233365b760@o1025753.ingest.sentry.io/4506480476487680",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});